export default "__VITE_ASSET__CYBD_vQf__"